import AppConfig from "../../config";
import httpClient from "../../utils/http-client";
import IdNameModel from "../../models/common/IdNameModel";
import BaseResponse from "../../models/common/BaseResponse";
import BaseResponseList from "../../models/common/BaseResponseList";
import CandidateProfileModel from "../../models/candidate/response/CandidateProfileModel";
import CandidateProfileRequest from "../../models/candidate/request/CandidateProfileRequest";
import ScheduleInterviewRequest from "../../models/candidate/request/ScheduleInterviewRequest";
import { CandidateDashboardModel } from "../../models/candidate/response/CandidateDashboardModel";
import InterviewRatingModel from "../../models/interviewer/response/InterviewRatingModel";
import CandidateAccessToViewProfileRequestModel from "../../models/candidate/request/CandidateAccessToViewProfileRequestModel";
import CandidateRelatedJobRequirementsSearchInputModel from "../../models/candidate/request/CandidateRelatedJobRequirementsSearchInputModel";
import CandidateRelatedJobRequirementRequestModel from "../../models/candidate/request/CandidateRelatedJobRequirementRequestModel";
import CandidateAccessToViewProfileGridModel from "../../models/candidate/response/CandidateAccessToViewProfileGridModel";
import PagedListModel from "../../models/common/PagedListModel";
import CandidateRelatedJobRequirementsGridModel from "../../models/candidate/response/CandidateRelatedJobRequirementsGridModel";
import CandidateStatusSearchInputModel from "../../models/candidate/request/CandidateStatusSearchInputModel";
import CandidateStatusModel from "../../models/candidate/response/CandidateStatusModel";
import CanidateStatusRequestModel from "../../models/admin/candidate/request/CanidateStatusRequestModel";

class CandidateService {
    async loadCandidateDesignation() {
        let res: BaseResponseList<IdNameModel[]> = await httpClient.get<BaseResponseList<IdNameModel[]>>(AppConfig.candidate.getCandidateDesignations);
        return res;
    };

    async getCandidateProfile(candidateId: string) {
        let res: BaseResponse<CandidateProfileModel> = await httpClient.get<BaseResponse<CandidateProfileModel>>(AppConfig.candidate.getCandidateProfile + "/" + candidateId);
        return res;
    };

    async saveCandidateProfile(candidateProfile: CandidateProfileRequest) {
        let res: BaseResponse<boolean> = await httpClient.post<BaseResponse<boolean>>(AppConfig.candidate.saveCandidateProfile, candidateProfile);
        return res;
    };

    async scheduleInterview(interview: ScheduleInterviewRequest) {
        let res: BaseResponse<boolean> = await httpClient.post<BaseResponse<boolean>>(AppConfig.candidate.candidateScheduleInterview, interview);
        return res;
    };

    async getCandidateDashboardDetails(candidateId: string) {
        let res: BaseResponse<CandidateDashboardModel> = await httpClient.get<BaseResponse<CandidateDashboardModel>>(AppConfig.candidate.getCandidateDashboardDetails + "/" + candidateId);
        return res;
    };

    async getInterviewRatingDetails(interviewId: string) {
        let res: BaseResponse<InterviewRatingModel> = await httpClient.get<BaseResponse<InterviewRatingModel>>(AppConfig.candidate.getInterviewRatingDetails + "/" + interviewId);
        return res;
    };

    async downloadCandidateResume(candidateId: string, fileDownloadType: string) {
        const res: any = await httpClient.get(
            AppConfig.fileUpload.downloadFile + "/" + candidateId + "/" + fileDownloadType,
            { responseType: "blob" }
        );
        return res;
        // let filename = "downloaded-file";
        // if (res && res.headers && res.headers["content-disposition"]) {
        //     const contentDisposition = res.headers["content-disposition"];
        //     const match = contentDisposition.match(/filename="?([^"]+)"?/);
        //     if (match && match[1]) {
        //         filename = match[1];
        //     }
        // }
        // return { data: res.data.data, filename }; // Return both blob and filename
    };

    async getCandidateAccessToViewProfileGrid(candidateId: string) {
        let res: BaseResponseList<CandidateAccessToViewProfileGridModel[]> = await httpClient.get<BaseResponseList<CandidateAccessToViewProfileGridModel[]>>(AppConfig.candidate.getCandidateAccessToViewProfileGrid + "/" + candidateId);
        return res;
    };

    async updateCandidateAccessToViewProfile(model: CandidateAccessToViewProfileRequestModel) {
        let res: BaseResponse<boolean> = await httpClient.post<BaseResponse<boolean>>(AppConfig.candidate.updateCandidateAccessToViewProfile, model);
        return res;
    };

    async getCandidateRelatedJobRequirement(model: CandidateRelatedJobRequirementsSearchInputModel) {
        let res: PagedListModel<CandidateRelatedJobRequirementsGridModel> = await httpClient.post<PagedListModel<CandidateRelatedJobRequirementsGridModel>>(AppConfig.candidate.getCandidateRelatedJobRequirement, model);
        return res;
    };

    async getCandidateAppliedJobRequirements(model: CandidateRelatedJobRequirementsSearchInputModel) {
        let res: PagedListModel<CandidateRelatedJobRequirementsGridModel> = await httpClient.post<PagedListModel<CandidateRelatedJobRequirementsGridModel>>(AppConfig.candidate.getCandidateAppliedJobRequirements, model);
        return res;
    };

    async saveCandidateJobApplication(model: CandidateRelatedJobRequirementRequestModel) {
        let res: BaseResponse<boolean> = await httpClient.post<BaseResponse<boolean>>(AppConfig.candidate.saveCandidateJobApplication, model);
        return res;
    };

    async getCandidateHistory(input: CandidateStatusSearchInputModel) {
        let res: PagedListModel<CandidateStatusModel> = await httpClient.post<PagedListModel<CandidateStatusModel>>(AppConfig.candidate.getCandidateHistory, input);
        return res;
    };

    async getCandidateStatus(candidateId: string) {
        let res: BaseResponse<CanidateStatusRequestModel> = await httpClient.get<BaseResponse<CanidateStatusRequestModel>>(AppConfig.admin.candidate.getCandidateStatus + "/" + candidateId);
        return res;
    };

    async checkIfCandidateHasSchedule(candidateId: string) {
        let res: BaseResponse<boolean> = await httpClient.get<BaseResponse<boolean>>(AppConfig.candidate.checkIfCandidateHasSchedule + "/" + candidateId);
        return res;
    };
}
const candidateService = new CandidateService();
export default candidateService;